module.exports = __webpack_public_path__ + "static/media/card_bg.7d3799ad.png";